import React, { useState } from 'react'
import { ArrowPathIcon } from '@heroicons/react/24/outline'
import Fetch from 'lib/fetch'
import clsx from 'clsx'

const ResetBaseline = ({ nodeId, mutate }) => {
  const [working, setWorking] = useState(false)

  const url = `/nodes/${nodeId}/baseline`

  const setBaseline = () => {
    setWorking(true)
    Fetch(url, {
      method: 'POST',
    }).then((response) => {
      if (response.ok) {
        setWorking(false)
        if (mutate) {
          mutate()
        }
      } else {
        response
          .json()
          .then((data) => alert(`Could not reset baseline: ${data.errors}`))
      }
    })
  }

  return (
    <div>
      {working ? (
        <ArrowPathIcon className="animate-spin w-4 h-4" />
      ) : (
        <button
          className={clsx(
            'disabled:opacity-50',
            'bg-mimic-black text-mimic-white px-2 py-1 text-xs',
            'rounded'
          )}
          onClick={() => {
            if (confirm('Are you sure you want to reset the baseline')) {
              setBaseline()
            }
          }}
        >
          Update baseline
        </button>
      )}
    </div>
  )
}

export default ResetBaseline
